import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkflowDataService } from '@nimmsta/ng-commons-lib/data-access';
import {
  WorkflowStatus,
  WorkflowTemplate,
} from '@nimmsta/ng-commons-lib/models';

@Injectable({ providedIn: 'root' })
export class WorkflowTemplateService extends WorkflowDataService<WorkflowTemplate> {
  protected override get apiEndpoint(): string {
    return '/workflow-template';
  }

  getDefinition(workflow: WorkflowTemplate): Observable<string> {
    return this.http.get<string>(`${this.baseUrl + this.apiEndpoint}/${workflow.id}/definition`);
  }

  updateDefinition(workflow: WorkflowTemplate, definition: string): Observable<WorkflowTemplate> {
    return this.http.put<WorkflowTemplate>(
      `${this.baseUrl + this.apiEndpoint}/${workflow.id}/definition`,
      definition,
    );
  }

  activateDeactivateWorkflow(workflow: WorkflowTemplate): Observable<WorkflowTemplate> {
    if (workflow.status === WorkflowStatus.ACTIVE) {
      return this.disable(workflow);
    } else {
      return this.activate(workflow);
    }
  }

  activate(workflow: WorkflowTemplate): Observable<WorkflowTemplate> {
    return this.http.post<WorkflowTemplate>(`${this.baseUrl + this.apiEndpoint}/${workflow.id}/activate`, {});
  }

  disable(workflow: WorkflowTemplate): Observable<WorkflowTemplate> {
    return this.http.post<WorkflowTemplate>(`${this.baseUrl + this.apiEndpoint}/${workflow.id}/disable`, {});
  }
}
